import { queryOptions } from "@tanstack/react-query";
import { adminApi, type AuditFilters, type WorkspaceFilters } from "./api";

export const ADMIN_KEY = ["admin"] as const;

export const adminWorkspacesQuery = (filters: WorkspaceFilters) =>
  queryOptions({
    queryKey: [...ADMIN_KEY, "workspaces", filters] as const,
    queryFn: () => adminApi.listWorkspaces(filters),
  });

export const adminWorkspaceQuery = (workspaceId: string) =>
  queryOptions({
    queryKey: [...ADMIN_KEY, "workspace", workspaceId] as const,
    queryFn: () => adminApi.getWorkspace(workspaceId),
  });

export const adminInvitesQuery = queryOptions({
  queryKey: [...ADMIN_KEY, "invites"] as const,
  queryFn: () => adminApi.listInvites(),
});

export const adminInviteRequestsQuery = (status: "new" | "all") =>
  queryOptions({
    queryKey: [...ADMIN_KEY, "invite-requests", status] as const,
    queryFn: () => adminApi.listInviteRequests(status),
  });

export const adminOperatorsQuery = (q: string) =>
  queryOptions({
    queryKey: [...ADMIN_KEY, "operators", q] as const,
    queryFn: () => adminApi.listOperators(q),
  });

export const adminErrorsQuery = (workspaceId: string | undefined) =>
  queryOptions({
    queryKey: [...ADMIN_KEY, "errors", workspaceId ?? null] as const,
    queryFn: () => adminApi.listErrors(workspaceId),
  });

export const adminWorkspaceConfigurationsQuery = (workspaceId: string) =>
  queryOptions({
    queryKey: [...ADMIN_KEY, "workspace-configurations", workspaceId] as const,
    queryFn: () => adminApi.workspaceConfigurations(workspaceId),
  });

export const adminWorkspaceMembersQuery = (workspaceId: string) =>
  queryOptions({
    queryKey: [...ADMIN_KEY, "workspace-members", workspaceId] as const,
    queryFn: () => adminApi.workspaceMembers(workspaceId),
  });

/** Audit pages are keyed by the filters only; the cursor is the infinite query's page param. */
export const auditQueryKey = (filters: AuditFilters) => [...ADMIN_KEY, "audit", filters] as const;
